export const APP_HOST =
	process.env.NEXT_PUBLIC_APP_HOST ||
	"https://vidsup.vercel.app"
